import ChangeOrderingModeSFC from "./ChangeOrderingMode.vue";
export const ChangeOrderingMode = ChangeOrderingModeSFC;
